// extracted by mini-css-extract-plugin
export default {"pocView":"styles_pocView__PUYHc"};